const Form098EN = {
    stepName: {
        statement: "Important Notes",
        basicInfo: "Basic Information",
        personalInfo: "Personal Information",
        declaration: "Declaration",
        confirmation: "Confirmation",
        partA: "Part A: Particulars of the Vacant Post",
        partB: "Part B: Particulars and Selection Assessment on the Candidate",
        partC: "Part C",
        partD: "Part D: Sexual Conviction Record Check (SCRC)",
        partE: "Part E: Basic Law and National Security Law Test (BLNST) ",
        // partF: "Part F: Vaccine Pass arrangements for government employees",
        partG: "Part F: Performance Appraisal",
    },
    headBar: {
        partA: "Part A: Particulars of the Vacant Post",
        partB: "Part B: Particulars and Selection Assessment on the Candidate",
        partC: "Part C",
        partD: "Part D: Sexual Conviction Record Check (SCRC)",
        partE: "Part E: Basic Law and National Security Law Test (BLNST)",
        partF: "Part F: Vaccine Pass” arrangements for government employees",
        PartG: "Part F: Performance Appraisal",
    },
    importantNotes: {
        1: "This Record shall be kept by School.",
        2: "For appointment of monthly-paid temporary teachers who have worked in the school in the previous school year, school should submit the last completed “Employment Record Form” of the teacher together with the salary assessment form and relevant supporting documents to the Government Schools Section.",
    },

    label: {
        agreement: "I have read and understood the above Important Notes.",
        source: "The candidate is selected from",
        sourceOption: {
            gs: "the list of applicant released by GS section",
            other: "other sources",
        },
        rankVacancyOption: {
            aeo: "AEO",
            apsm: "APSM",
            cm: "CM",
            steam: "STEAM teacher (for government primary school)",
            ltii: "LT II",
        },
        rankEmploymentOption: {
            gm: "GM",
            apsm: "APSM",
            cm: "CM",
            steam: "STEAM teacher (for government primary school)",
            ltii: "LT II",
        },
        rankEmploymentOption2: {
            gm: "GM",
            apsm: "APSM",
            cm: "CM",
            steam: "STEAM teacher (for government primary school)",
            ltii: "LT II",
        },
        selectResultOption: {
            Selected: "Selected",
            Waitlist: "Waitlist",
            Rejected: "Rejected",
        },
        selectReasonOption: {
            Selected: "Selection",
            Waitlist: "Waitlist",
            Rejected: "Rejection",
        },
        selectOfficeOption: {
            Interviewer: "Interviewer",
            officer: "officer",
        },
        scrcResultOption: {
            doesNot: "does not have a Sexual Conviction Record",
            hasA: "has a Sexual Conviction Record",
            withdrew:
                "withdrew result of the check (Please contact the applicant for the details)",
        },
        learnLevelOption: {
            veryGood: "Very good",
            good: "Good",
            satisfactory: "Satisfactory",
            unsatisfactory: "Unsatisfactory",
        },
        bltResultOption: {
            pass: "pass (please attach a copy of the test result)",
            notApplicable: "Not applicable",
        },

        schoolName: "School",
        schoolYear: "School Year",
        uploadPartGTitle:
            'Upload Part F (Performance Appraisal) of "Employment Record Form" of Previous School Year (Applicable to re-appointment)',
        uploadFile: "Upload File",
        uploadAssessmentResult: "Assessment result is attached",

        vacancy: "Vacancy and Previous post-holder",
        previousPostHolder: "Previous post-holder",
        conVacancy: "Rank of the consequential vacancy",
        reason: "Reason",
        vacanctDuration: "Duration of vacancy",
        subLevTaught: "Subjects/levels taught",
        otherDuties: "Other duties",

        applicationNo:
            "Substitute Teacher Application No. (EDB113) (if applicable)",
        specify: "Please specify",
        rankForEmployment: "Rank for employment",
        cmSpecify:
            "Please provide justifications for the employment at CM rank, if applicable",
        englishName: "Name in English",
        chineseName: "Name in Chinese",
        idNo: "ID No.",
        teacherNo: "Teacher Registration No.",
        birthDate: "Date of Birth",
        medicalCertificate:
            "medical certificate is mandatory if the candidate is over 60 years old",
        dateBoard: "Date of the Board",
        boardTitle: "Composition of the Board (at least 2 Board members)",
        chairpersonName: "Name of the chairperson",
        otherBoardName: "Name of other Board member",
        post: "Post",
        annex: "<b>Assessment criteria</b> adopted by the interview board (A sample is provided at Attachment to form for reference. School may adopt the sample or school-based assessment criteria and weightings as appropriate. <b>The assessment result should be attached to the Employment Record Form</b>. If assessment mode other than interview board (e.g. trial lesson, written test and/or trial marking) is conducted, please include it in assessment criteria.)",
        firstApprover: "First Approver",
        secondApprover: "Second Approver",

        // partC
        declareCheck:
            "We declare that the candidate has no affiliation with any of us that unduly affects or upsets the selection/employment process and decision.",
        selectionResult: "Selection Result",
        waitlistNo: "Waitlist(No.)",
        selectReason: "Reasons for Selection / Waitlist / Rejection",
        selectOffice: "Name of Interviewer / officer 1",
        selectOffice2: "Name of Interviewer / officer 2",
        postHeld: "Post Held",

        // partD
        partdBar:
            "All substitute teachers (both monthly-paid and daily-paid) should be requested to undergo the SCRC.  ",
        checkCode: "Checking code",
        scrcResult: "Results of the SCRC",
        scrcRemark: "Remarks",
        transactionNo: "Transaction No. provided by the SCRC System",
        checkName: "Checked by (Name)",
        checkNameError: "Please enter a correct name",
        rankHeld: "Rank / Post Held",

        // partE
        partETitle:
            "Starting from the {{schYear}} school year, newly-appointed teachers in all public sector schools, including monthly-paid temporary teachers in government schools, are required to obtain a pass in the BLNST conducted by the Civil Service Bureau or the Education Bureau.",
        bltResult: "Results of the BLNST",
        testResultCopy: "please attach a copy of the test result",

        // partF
        isCompliedVaccine:
            "fully complied with the prevailing vaccination requirements",
        vaccineRemarks: "Remarks",

        // partG
        parteBar:
            "This part is also applicable for daily-paid supply teachers. For monthly-paid temporary teachers, school should conduct appraisal interviews.)",
        // learnLevel: "Level of Performance Learning",
        learnLevel:
            "Fully complied with the prevailing vaccination requirements",
        otherRemarks: "Other remarks for performance",
        appraiseOffiName: "Name of Appraising Officer",
        endorOffiName: "Name of Endorsing Officer",
        officerTitleOption: {
            ao: "Appraising Officer",
            eo: "Endorsing Officer",
        },
    },
    errorMsg: {
        arrMin: "At least 2 Board members",
        ageDate:
            "The applicant is at least 18 years old at the time of submission.",
        eightDigit: "This field must be 6 digits.",
    },
    notes: {
        partB1: "With the full implementation of all-graduate teaching force policy, temporary teachers employed by government secondary or primary school should possess a degree from a local university or equivalent (the degree means a Bachelor degree).  When suitable candidates mentioned above cannot be recruited under very special circumstances, teachers with prescribed qualification/training may be employed as temporary teachers in CM rank.",
        partC2: "Reasons for making offers/rejection, key information and justification for the selection result, etc. should be provided.",
        partC3: "For employment of a daily-paid supply teacher, if an interview board is not conducted, the officer(s) who handle(s) the appointment shall sign here.  ",
    },
    blockMsg:
        "Applicant may enter the form filling page after the Master School Administrator (MSA) or School Head has delegated the approvers.",
    editDialog: {
        title: "Notice",
        note1: "You could sign the application after another approver of Part A-E submitted the application.",
        note2: "You could sign the application after the other approver of Part F submitted the application.",
    },
    signature: {
        applicant0:
            "Part A-E is submitted and signed by <b>{{name}} {{post}}</b>.",
        approver0:
            "Part A-E is 1st approved and signed by <b>{{name}} {{post}}</b>.",
        approver1:
            "Part A-E is 2st approved and signed by <b>{{name}} {{post}}</b>.",
        secApprover:
            "This form is 2nd approved and signed by <b>{{name}} {{post}}</b>.",
        thirdApprover:
            "This form is 3rd approved and signed by <b>{{name}} {{post}}</b>.",
        fourthApprover0:
            "Part F is 1th approved and signed by <b>{{name}} {{post}}</b>.",
        fourthApprover1:
            "Part F is 2th approved and signed by <b>{{name}} {{post}}</b>.",
        reviewer:
            "This form is accepted and signed by <b>{{name}} {{post}}</b>.",
        view: "View Signature",
    },
    approverDelegation: {
        partAToF: "Form Delegation (Approvers of Part A-E)",
        partG: "Form Delegation (Approvers of Part F)",
    },
    submittedDialog: {
        multiLayerSubmitMsg:
            "You are about to be redirected to input your Name and Post Title.",
    },
};
export default Form098EN;
